/**
 * Hybrid Badge Component
 * Automatically chooses between Tailwind and styled-components based on props
 */

import * as React from "react";
import { Icon } from "@sproutsocial/seeds-react-icon";
import { StyledBadge } from "./styles"; // Styled-components version
import { BadgeTailwind } from "./BadgeTailwind"; // Tailwind version
import { hasStyledProps } from "@sproutsocial/seeds-react-system-props";
import type { TypeBadgeProps } from "./BadgeTypes";

const BadgeHybrid = ({
  children,
  iconName,
  size = "small",
  badgeColor = "blue",
  color,
  ...rest
}: TypeBadgeProps) => {
  // A custom `color` is a styled-system prop, so it routes through the
  // styled-components path (matching Button semantics).
  if (color !== undefined || hasStyledProps(rest)) {
    return (
      <StyledBadge
        size={size}
        badgeColor={badgeColor}
        data-qa-badge
        // TODO: fix this type since `color` should be valid here. TS can't resolve the correct type.
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        color={color}
        {...rest}
      >
        {iconName ? (
          <Icon
            mr={200}
            name={iconName}
            size={size === "small" ? "mini" : "small"}
            aria-hidden
          />
        ) : null}
        {children}
      </StyledBadge>
    );
  }

  // Use Tailwind version (preferred - better performance)
  return (
    <BadgeTailwind
      size={size}
      badgeColor={badgeColor}
      iconName={iconName}
      {...rest}
    >
      {children}
    </BadgeTailwind>
  );
};

export default BadgeHybrid;
